import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import Form from "./components/Form/Form";
import Home from "./pages/Home/Home";
import NftDataContainer from "./components/Nft/NftConiatner";
import { FaDonate } from "react-icons/fa";
import Profile from "./pages/Profile/Profile";
import Collection from "./pages/Collection/Collection";
import Support from "./components/Support/Support";
import {
  AppContainer,
  HeaderContainer,
  Heading,
  Nav,
  Container,
  Footer,
  CreatorContainer,
  Header,
} from "./globalStyle";

function App(props) {
  const [nftId, setNftID] = useState();
  const address = "hx38c5fea8a8321e17a8ee7c6b5835a4731b1134cf";
  const [nftDataLoaded, setNftDataLoaded] = useState(false);
  const [hideNFTview, setHideNFTview] = useState(true);
  const [NftData, setNftData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  useEffect(() => {}, [setNftID]);

  const hideView = () => {
    setHideNFTview((prevState) => !prevState);
  };
  return (
    <AppContainer hideNFTview={hideNFTview}>
      <Router>
        <HeaderContainer>
          <Header>
            <Link style={{ textDecoration: "none" }} to="/">
              <Heading>
                Rarity Roll
                <br />
                <span>"Check how rare your nft is"</span>
              </Heading>
            </Link>
            <Link
              style={{
                textDecoration: "none",
                marginTop: "5px",
              }}
              to="/support"
            >
              <Nav> Support !</Nav>
            </Link>
          </Header>
        </HeaderContainer>
        <Routes>
          <Route
            path="/"
            element={
              <Home
                nftId={nftId}
                setNftID={setNftID}
                NftData={NftData}
                setNftData={setNftData}
                hideNFTview={hideNFTview}
                setHideNFTview={setHideNFTview}
                loading={loading}
                setLoading={setLoading}
              />
            }
            exact
          />
          <Route
            path="/profile/:id"
            element={<Profile NftData={NftData} />}
            exact
          />
          <Route path="/collection/:name" element={<Collection />} exact />
          <Route path="/support" element={<Support />} exact />
        </Routes>
        {/* <Route path="/home" component={Home} />
        <Route path="/register" component={Register} />
        <Route path="/coupons" component={Coupon} />
        <Route path="/search" component={Compare} /> */}
      </Router>
      <Container>
        {/* {hideNFTview && (
          <Form
            nftId={nftId}
            setNftID={setNftID}
            NftData={NftData}
            setNftData={setNftData}
            hideNFTview={hideNFTview}
            setHideNFTview={setHideNFTview}
            loading={loading}
            setLoading={setLoading}
          />
        )} */}
        {/* {!hideNFTview && (
          <NftViewContainer>
            <CloseButton onClick={hideView}> Hide NFT Profile</CloseButton>
            {NftData && <NftDataContainer nftData={NftData} />}
          </NftViewContainer>
        )} */}
        <CreatorContainer style={{ display: "none" }}>
          <p>
            Designed and Developed By{" "}
            <a href="https://twitter.com/akhyl_chhetri">Akhil Chhetri</a>
            <br />
            <FaDonate style={{ marginTop: "2rem" }} /> &nbsp;
            <span style={{ color: "#f39c12" }}>
              {" "}
              Buy me Cup of Coffee ($ICX, $GBET, $BALN, NFTs or any ICON network
              Assets):
            </span>
            <br />
            <br />
            <span
              style={{
                marginTop: "1rem",
                paddingTop: "1rem",
              }}
            >
              Wallet Address(Click To Copy) :{" "}
              <span
                onClick={() => {
                  navigator.clipboard.writeText(address);
                  alert("Address Copied Success");
                }}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                hx38c5fea8a8321e17a8ee7c6b5835a4731b1134cf
              </span>
            </span>
          </p>
        </CreatorContainer>
        <Footer>
          <span>2022 &#169; Rarity Roll</span>
        </Footer>
      </Container>
    </AppContainer>
  );
}

export default App;
